import { render } from "./ListeCollecte.vue?vue&type=template&id=79efab90"
import script from "./ListeCollecte.vue?vue&type=script&lang=js"
export * from "./ListeCollecte.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__